// extracted by mini-css-extract-plugin
module.exports = {"red-dot-after":"RedDot_red-dot-after__W6alQ","red-dot-before":"RedDot_red-dot-before__i9Kyf"};